import React from 'react'
import GuestSettingsContainer from './GuestSettingsContainer'
import AdminSettingsContainer from './AdminSettingsContainer'

const Settings = ({guest, ...props}) => (guest) ? (
  <GuestSettingsContainer {...props} />
) : (
  <AdminSettingsContainer {...props} />
)

export default Settings



// WEBPACK FOOTER //
// ./src/routes/Settings/index.js